import PropTypes from 'prop-types';

export const REGION_DATA = {
  id: PropTypes.number,
  name: PropTypes.string,
  shortName: PropTypes.string,
  regionId: PropTypes.number,
  polygon: PropTypes.string,
  lat: PropTypes.number,
  long: PropTypes.number,
  unlocode: PropTypes.string
};

export const LOCATIONS = {
  type: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.number,
  isoAlpha2: PropTypes.string,
  locode: PropTypes.string
};

export const PORT = {
  id: PropTypes.number,
  portName: PropTypes.string,
  unlocode: PropTypes.string,
  countryId: PropTypes.number,
  active: PropTypes.bool,
  cpointlat: PropTypes.number,
  cpointlon: PropTypes.number,
  terminals: PropTypes.arrayOf(PropTypes.shape(TERMINAL)),
  country: PropTypes.shape(COUNTRY)
};

export const PORT_DETAILS = {
  ...PORT,
  countryName: PropTypes.string,
  countryId: PropTypes.number,
  isoAlpha2: PropTypes.string,
  country: null
};

export const COUNTRY = {
  id: PropTypes.number,
  name: PropTypes.string,
  subnational: PropTypes.bool,
  isoAlpha3: PropTypes.string,
  isoAlpha2: PropTypes.string,
  m49: PropTypes.number,
  countryId: PropTypes.number,
  country: PropTypes.shape(COUNTRY),
  ports: PropTypes.arrayOf(PropTypes.shape(PORT))
};

export const TERMINAL = {
  id: PropTypes.number,
  terminalName: PropTypes.string,
  terminalLat: PropTypes.number,
  terminalLong: PropTypes.number,
  radius: PropTypes.number,
  portId: PropTypes.number
};
